import React, {useEffect} from 'react';
import {Col, Row} from "react-bootstrap";



const BasketDelivery = ({address, mart}) => {
    const [distance, setDistance] = React.useState(0);

    let rad = function(x) {
        return x * Math.PI / 180;
    };

    let getDistance = function(mart, address) {
        let R = 6378137; // Earth’s mean radius in meter
        let dLat = rad(address.geoLat - mart.geoLat);
        let dLong = rad(address.geoLon - mart.geoLon);
        let a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(rad(mart.geoLat)) * Math.cos(rad(address.geoLat)) *
            Math.sin(dLong / 2) * Math.sin(dLong / 2);
        let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        let d = R * c;
        setDistance(d)
    };

    useEffect(() => {
        getDistance(mart, address)
    }, [address, mart]);

    return (
        <>
            <Row>
                <Col>
                    {distance > 500 ?
                        <>
                            Стоимость доставки:<br/>
                            Платная доставка 120 Р
                            <br/>
                        </>
                        :
                        <>
                            Бесплатная доставка
                            <br/>
                        </>
                    }
                    <br/>

                </Col>
            </Row>
            <Row>
                <Col>
                    {distance > 500 ?
                        <>
                            Средне время доставки:<br/>
                            60 мин
                            <br/>
                        </>
                        :
                        <>
                            Время доставки:<br/>
                            от 15 мин
                            <br/>
                        </>
                    }
                    <br/>
                </Col>
            </Row>
        </>
    );
};

export default BasketDelivery;